// Module
var code = `<div class="bg-pane-left bg-pane" ng-transclude="left"></div><bg-handle disabled="\$ctrl.disabled" ng-class="{ 'disabled': \$ctrl.disabled }"></bg-handle><div class="bg-pane-right bg-pane" ng-transclude="right"></div>`;
// Exports
export default code;